import { map as _map, find as _find } from 'lodash';
import { format, isValid, parseISO } from 'date-fns';
import { EXAMINATION_ACTION_ID } from '../../config';
import { findActionById } from './claim';

const formatDateIfValid = (dateString, formatString = 'dd/MM/yyyy') => {
  const isDateValid = isValid(parseISO(dateString));
  return isDateValid ? format(parseISO(dateString), formatString) : '';
};

const determineInvoiceType = (invoice) => (invoice.isGuarantee === '0' ? 'APPLICATION' : 'REPAIR');

const determineCascoStatus = (claim) => {
  const { claimStatus, claimType, declarationDate, invoices, actions } = claim;

  const isClaimOpen = claimStatus === 'Opened';
  const isClaimTypeChosen = claimType !== '' && claimType !== null;

  // Առկա են դիմումներ
  const hasApplications = isValid(parseISO(declarationDate));

  /** Հայտի գրանցում
   * 0. Հայտը բաց է
   * 1. Հայտի տեսակը ընտրված է
   * 2. Դիմումներ առկա չեն
   */
  if (isClaimOpen && isClaimTypeChosen && !hasApplications) {
    return { status: 'REGISTRATION', detailedStatus: 'REGISTRATION' };
    // Պատահարի ամսաթիվ -> claims->event_date
  }

  const isAccelerated = claimType === 'Արագացված 400,000' || claimType === 'Արագացված 200,000';

  // հաշիվը հաստատված է, եթե առկա է այդ հաշվի accept_date փոփոխականը իր արժեքով։
  const hasApprovedInvoice = !!invoices.length
    && !!_find(invoices, (o) => isValid(parseISO(o.acceptDate)));

  /** Դիմումի ընդունում
   * 0. Հայտը բաց է
   * 1. Հայտի տեսակը ընտրված է,
   * 2. Առկա են հաստատված դիմումներ, իսկ արագացված 400000 կամ արագացվաած 200000
        հայտի տեսակների դեպքում, նաև այն դեպքում, երբ դիմումներ առկա չեն
        (*Առկա են հաստատված դիմումներ === Առկա են դիմումներ)
   * 3. Հաշիվներ հատվածում գրանցված ուղեգրերը և հաշիվները հաստատված չեն // (*ուղեգրերը - ignore)
   */
  if (
    isClaimOpen
    && isClaimTypeChosen
    && (hasApplications || isAccelerated)
    && !hasApprovedInvoice
  ) {
    return { status: 'ACCEPTANCE', detailedStatus: 'ACCEPTANCE' };
    // Պատահարի ամսաթիվ -> claims->event_date
    // Դիմումի ամսաթիվ -> claims→declaration_date
  }

  const invoice = invoices && invoices[0];
  if (!invoice) {
    // this shouldn't happen, but just in case
    return { status: '', detailedStatus: '' };
  }

  if (determineInvoiceType(invoice) === 'REPAIR') {
    return { status: 'SENT_TO_REPAIR', detailedStatus: 'SENT_TO_REPAIR' };
  }

  /** Հայտի Փորձաքննություն
   * 0. Հայտը բաց է
   * 1. Հայտի տեսակը ընտրված է,
   * 2. Առկա են հաստատված դիմումներ, իսկ արագացված 400000 կամ արագացվաած 200000
        հայտի տեսակների դեպքում, նաև այն դեպքում, երբ դիմումներ առկա չեն
   * 3  Հաշիվներ հատվածում գրանցված ուղեգիրը հաստատված է (*ignore)
   * 4. Հաշիվներ հատվածում առկա հաշիվը հաստատված է:
   * 5. claims->actions->action : action_id = 10 || 11
   */

  if (
    isClaimOpen
    && isClaimTypeChosen
    && (hasApplications || isAccelerated)
    && hasApprovedInvoice
    && !!findActionById(actions, EXAMINATION_ACTION_ID)
  ) {
    return { status: 'EXAMINATION', detailedStatus: 'EXAMINATION' };
    // Պատահարի ամսաթիվ -> claims->event_date
    // Դիմումի ամսաթիվ -> claims→declaration_date
    // Գնահատման ամսաթիվ -> claims->invoices->invoice_date
    // Փորձաքննույան ամսաթիվ -> claims->actions->action_date
  }

  /** Հայտի Գնահատում
   * 0. Հայտը բաց է
   * 1. Հայտի տեսակը ընտրված է,
   * 2. Առկա են հաստատված դիմումներ,իսկ արագացված 400000 կամ արագացվաած 200000
        հայտի տեսակների դեպքում, նաև այն դեպքում, երբ դիմումներ առկա չեն
   * 3 Հաշիվներ հատվածում գրանցված ուղեգրիրը հաստատված է // (*ուղեգրիրը - ignore)
   */
  if (
    isClaimOpen
    && isClaimTypeChosen
    && (hasApplications || isAccelerated)
    && hasApprovedInvoice
  ) {
    return { status: 'ASSESSMENT', detailedStatus: 'ASSESSMENT' };
    // Պատահարի ամսաթիվ -> claims->event_date
    // Դիմումի ամսաթիվ -> claims→declaration_date
    // Գնահատման ամսաթիվ -> claims->invoices->invoice_date
  }

  const hasInvoicePayDate = isValid(parseISO(invoice.invoicePayDate));

  /** Հայտի կարգավորում
   *    Հատուցված ->
   *      Հայտը փակ է
   *      կարգավիճակը setisfied է claim_status = 2
   *    Չեղարկված ->
   *      հատը ընդհանուր գտնվում է փակ կարգավիճակում
   *      claim_status = 4
   *    Մերժված ->
   *      Հայտը փակ է
   *      կարգավիճակը rejected է  --> claim_status = 3
   */
  if (!isClaimOpen && !hasInvoicePayDate) {
    switch (claimStatus) {
      case 'Satisfied':
        return { status: 'SETTLEMENT', detailedStatus: 'COMPENSATED' };
      // Պատահարի ամսաթիվ -> claims->event_date
      // Դիմումի ամսաթիվ -> claims→declaration_date
      // Գնահատման ամսաթիվ -> claims->invoices->invoice_date
      // Փորձաքննույան ամսաթիվ -> claims->actions->action_date
      // Կարգավորման ամսաթիվ = Հաշվի կարգավորման ամսաթիվ -> claims->close_date
      // --- hide if expense_type !== 1(Մուծում շահառուին)
      // Գնահատված գումար = Հաշվի ներկայացված գումարի չափ -> claims->invoices->invoice_amount
      // Չհատուցվող գումար =Ֆրանշիզա -> claims->risks->total_deductible
      // Հատուցված գումար = Հատուցված գումարի չափ -> claims->invoices->amount_left
      case 'Canceled':
        return { status: 'SETTLEMENT', detailedStatus: 'CANCELED' };
      // Պատահարի ամսաթիվ -> claims->event_date
      // Չեղարկման ամսաթիվ ->  close_date
      default:
        // Unsatisfied or Rejected (claim_status = 3)
        return { status: 'SETTLEMENT', detailedStatus: 'REJECTED' };
      // Մերժման ամսաթիվ = Հայտի կարգավորման ամսաթիվ
      // Գնահատված գումար = Հաշվի ներկայացված գումարի չափ -> claims->invoices->invoice_amount
      // Չհատուցվող գումար = Ֆրանշիզա, եթե առկա է claims->risks->total_deductible
      // Մերժված գումար = (Ներկայացված գումարի չափ - Գումար), Նույն ձևով ինչ-որ նախորդ դեպքերում
    }
  }

  /** Վճարում
   *  Հայտը փակ է և կարգավիճակը setisfied է --> claim_status = 2
   *  Հաշվի կարգավիճակը վճարված է, այսինքն վճարման ամսաթիվը լրացված է
   */
  // if (claimStatus === 'Satisfied' && hasInvoicePayDate)
  return { status: 'PAYMENT', detailedStatus: 'PAYMENT' };
  // Կարգավորման ամսաթիվ = Հաշվի կարգավորման ամսաթիվ -> claims->close_date
  // Վճարման ամսաթիվ = Վերջին վճարման օր -> claims->invoices->invoice_pay_date
  // Գնահատված գումար = Հաշվի ներկայացված գումարի չափ -> claims->invoices->invoice_amount
  // Չհատուցվող գումար = Ֆրանշիզա, եթե առկա է claims->risks->total_deductible
  // Մերժված գումար = (Ներկայացված գումարի չափ - Գումար), Նույն ձևով ինչ-որ նախորդ դեպքերում
  // Հատուցված գումար = Հատուցված գումարի չափ -> claims->invoices->amount_left
  // hide if expense_type !== 1
  // Պատահարի ամսաթիվ -> claims->event_date
  // Դիմումի ամսաթիվ -> claims→declaration_date
};

const getCascoInvoices = (claim) => {
  const {
    claimNumber,
    eventDate,
    declarationDate,
    closeDate,
    invoices,
    actions,
    risks,
  } = claim;

  const { status, detailedStatus } = determineCascoStatus(claim);

  const formattedCloseDate = formatDateIfValid(closeDate);

  const examAction = findActionById(actions, EXAMINATION_ACTION_ID);

  const result = {
    isCasco: true,
    status,
    detailedStatus,

    // table five columns
    invoiceInputDate: formatDateIfValid(eventDate),
    isStateOpen: !['SETTLEMENT', 'PAYMENT'].includes(status),
    type: 'APPLICATION',
    assessmentAmount: null,
    settledAmount: null,

    declarationDate: formatDateIfValid(declarationDate),
    settlementDate: formattedCloseDate,
    canceledDate: formattedCloseDate,
    rejectedDate: formattedCloseDate,
    examinationDate: examAction && examAction.actionDate,

    assessmentDate: '',
    invoicePayDate: '',
    deductibleAmount: null,
    rejectedAmount: null,
  };

  const showSettledAmount = ['SETTLEMENT', 'PAYMENT', 'SENT_TO_REPAIR'].includes(status);

  let risksAsInvoices = [];

  if (invoices.length === 0) {
    // no invoices yet - show minimal info
    risksAsInvoices = risks.map((risk, i) => ({
      ...result,
      type: 'APPLICATION',
      rowId: `${claimNumber}-risk-${i}`,
      riskLabel: risk.riskLabel,
    }));

    return risksAsInvoices;
  }

  const invoice = invoices.length && invoices[0];
  const showAssessmentAmount = invoice.invoiceStatus === '1';

  if (invoice && risks) {
    // in case of CASCO we treat each invoice.risks as a separate invoice

    risksAsInvoices = risks
      .map((risk, i) => ({
        ...result,
        type: determineInvoiceType(invoice),
        rowId: `${claimNumber}-risk-${i}`,
        riskLabel: risk.riskLabel,

        assessmentAmount: showAssessmentAmount ? parseFloat(risk.totalAmount) : null,
        deductibleAmount: parseFloat(risk.totalDeductible),
        coveragePercent: parseFloat(risk.totalAmountPercent),
        amountAfterCoverage: parseFloat(risk.totalSettleAmount),
        settledAmount: showSettledAmount
          ? parseFloat(risk.totalSettleAmount) - parseFloat(risk.totalDeductible)
          : null,

        assessmentDate: formatDateIfValid(invoice.invoiceDate),
        invoicePayDate: formatDateIfValid(invoice.invoicePayDate),
        acceptDate: formatDateIfValid(invoice.acceptDate),

        invoiceExpenseType: invoice.invoiceExpenseType,
        invoiceCurrency: invoice.invoiceCurrency,
      }));
  }

  return risksAsInvoices;
};

const prepareCascoClaims = (claims) => {
  if (!claims) {
    return [];
  }

  return _map(claims, (claim) => ({
    ...claim,
    isCasco: true,
    invoices: getCascoInvoices(claim),
  }));
};

export default prepareCascoClaims;
